import { createApp } from 'vue'
import App from './App.vue'
import homePage from './pages/homePage.vue'
import databasePage from './pages/databasePage.vue'
import newUser from './components/newUser.vue'
import { createRouter, createWebHistory } from 'vue-router'

const routes = [
    { path: '/', component: homePage },
    { path: '/database', component: databasePage },
    { path: '/newUser', component: newUser },
    ]

const router = createRouter({
    history: createWebHistory(),
    routes,
    })

const app = createApp(App)
app.use(router)
app.mount('#app')
